import FormErrorText from '@ssg/common/Components/FormErrorText';
import React from 'react';
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';

import Button from '@ssg/common/Components/Button';
import { ESDHFileFragment } from '@ssg/common/GraphQL';

interface Props {
	signatureFile: ESDHFileFragment | undefined;
	onSubmit: (signature: { base64: string; extension: string }) => unknown;
	onClear: () => unknown;
	label?: string;
	errorMessage?: string;
	isUploading: boolean;
	required?: boolean;
}

const extension = 'png';

const SignatureInput: React.FC<Props> = ({ onSubmit, onClear, signatureFile, label, errorMessage, isUploading, required = true }) => {
	const canvasRef = React.createRef<ReactSketchCanvasRef>();
	return (
		<div className="w-full">
			{label != null && (
				<label className=" text-blue text-base font-semibold">
					{label} {required && <span className="text-red">*</span>}
				</label>
			)}

			{signatureFile != null && <img src={signatureFile.thumbnail} alt="signature" style={{ height: 250 }} />}

			{signatureFile == null && <ReactSketchCanvas height="250px" strokeColor="black" ref={canvasRef} />}

			{errorMessage && <FormErrorText text={errorMessage} />}

			<div className="flex justify-between mt-2">
				<Button
					success
					loading={isUploading}
					disabled={signatureFile != null}
					onClick={async () => {
						if (canvasRef.current == null) return;
						const base64 = await canvasRef.current.exportImage(extension);
						onSubmit({ base64, extension });
					}}
					text="reports.signatureInput.save"
				/>

				<Button
					danger
					onClick={() => {
						canvasRef.current?.clearCanvas();
						onClear();
					}}
					text="reports.signatureInput.clear"
				/>
			</div>
		</div>
	);
};

export default SignatureInput;
